export const GIVING_TERMS_VERSION = 'v1';
const STORAGE_KEY = 'unity.givingTermsAccepted';

function browserStorage(): Storage | null {
  try {
    return globalThis.localStorage;
  } catch {
    return null;
  }
}

export function hasAcceptedGivingTerms(): boolean {
  return browserStorage()?.getItem(STORAGE_KEY) === GIVING_TERMS_VERSION;
}

export function rememberGivingTermsAccepted(): void {
  try {
    browserStorage()?.setItem(STORAGE_KEY, GIVING_TERMS_VERSION);
  } catch {
    // Private browsing or blocked storage — the dialog will show again next time.
  }
}

export function consoleLegalUrl(path: 'terms' | 'privacy'): string {
  return path === 'terms'
    ? 'https://unitychurchmanager.com/terms'
    : 'https://unitychurchmanager.com/privacy';
}
